var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataSets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1072_9387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 2.71997C15.18 2.71997 12.6667 3.59997 12.6667 5.2733V6.31997C16.2 6.4933 18.6667 8.0533 18.6667 10.16V14.6266L18.7 14.6666C20.7867 14.4533 22.6333 13.6 22.6333 12.1666V5.2733C22.6667 3.59997 20.1533 2.71997 17.6667 2.71997Z",
    fill: "#A1A1AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 6.32005V5.27338C11.3333 3.59338 8.82 2.71338 6.33333 2.71338C3.84667 2.71338 1.33333 3.60005 1.33333 5.27338V12.16C1.33333 13.6 3.18 14.4467 5.26667 14.6667L5.33333 14.62V10.1534C5.33333 8.05338 7.8 6.49338 11.3333 6.32005Z",
    fill: "#A1A1AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.23328C8.71334 7.23328 6.23334 8.48661 6.23334 10.1533V18.3599C6.23334 20.0266 8.71334 21.2799 12 21.2799C15.2867 21.2799 17.7667 20.0266 17.7667 18.3599V16.9199C16.1003 18.1435 14.0653 18.7599 12 18.6666C10.6372 18.6896 9.28166 18.4637 8 17.9999V16.8466C9.26276 17.3879 10.6264 17.6538 12 17.6266C14.8067 17.6266 17.1 16.8066 17.7533 15.4733V13.6466C16.5333 14.6666 14.48 15.3333 12 15.3333C10.6372 15.3563 9.28166 15.1304 8 14.6666V13.4866C9.26276 14.0279 10.6264 14.2938 12 14.2666C14.8067 14.2666 17.1 13.5266 17.7533 12.1933V10.1533C17.7667 8.48661 15.2867 7.23328 12 7.23328Z",
    fill: "#A1A1AA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1072_9387"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSets);
export default __webpack_public_path__ + "static/media/data_sets.6b5144fdda0c618d93a61a9991236ed0.svg";
export { ForwardRef as ReactComponent };